export default __webpack_public_path__ + "static/media/Yellow-Desktop-Icon.ff9a3ea9.png";